import Echo from 'laravel-echo';
import { debounce } from 'lodash-es';
window.Pusher = require('pusher-js');

export const initEcho = async store => {
  await store.dispatch('getPusherConfiguration');
  const { host, key, broadcaster } = store.state.launcher.pusherConfiguration;
  const echoConfiguration = {
    broadcaster: 'pusher',
    wsHost: host,
    key,
    disableStats: true,
    encrypted: true,
    authEndpoint: `https://${window.sbvrenv.API_URL}/v1/broadcasting/auth`,
    auth: {
      headers: {
        XBroadcaster: broadcaster,
        Authorization: `Bearer ${store.state.auth.token}`,
      },
    },
  };
  window.echo = new Echo(echoConfiguration);
  if (store.state.route.name === 'videoreel') {
    // for videoreel we just need to subscribe to station settings update
    window.echo.join(`App.Station.${store.getters.stationId}`);
    window.echo
      .private(`App.Station.${store.getters.stationId}`)
      .listen('.Station', ({ station }) => {
        store.dispatch('getStation');
      });
  } else {
    const debounceBookingUpdate = debounce(
      () => store.dispatch('getTodaysBookings'),
      500,
    );
    window.echo.join(`App.Station.${store.getters.stationId}`);
    window.echo
      .private(`App.Station.${store.getters.stationId}`)
      .listen('.Station', ({ station }) => {
        store.dispatch('diffStationAndRefresh', station);
      })
      .listen('.Location', data => {
        store.dispatch('getStation');
      })
      .listen('.Organization', data => {
        store.dispatch('getStation');
      })
      .listen('.Experience', data => {
        // experience event is fired across all station without any regards to relationship (for handling station sorting) this is why we need to filter it out
        const { currentStation } = store.getters;
        const { experience } = data;
        if (currentStation.experience.id === experience.id) {
          store.dispatch('getStation');
          store.dispatch('getStationTags');
        }
      })

      .listen('.Booking', debounceBookingUpdate)
      .listen('.BookingStationTime', debounceBookingUpdate)
      // .listen('.Game', data => { console.log('socket: ', data) })
      .listen('.ReloadStationGame', () => {
        store.dispatch('getStationTags');
      })
      .listen('.StationGameLaunch', ({ game, launcher }) => {
        if (game) store.dispatch('startGameWithRestart', game.id);
        if (launcher) store.dispatch('startLauncherWithRestart');
      });
  }
};
// initEcho(token)
